__turbopack_context__.v({
  "--ad-text-is-above": "sponsor-display-module-scss-module__Ak7adW__--ad-text-is-above",
  "--ad-text-is-to-the-left": "sponsor-display-module-scss-module__Ak7adW__--ad-text-is-to-the-left",
  "--tier-one-is-solo": "sponsor-display-module-scss-module__Ak7adW__--tier-one-is-solo",
  "--tier-two-is-solo": "sponsor-display-module-scss-module__Ak7adW__--tier-two-is-solo",
  "__ad-image": "sponsor-display-module-scss-module__Ak7adW____ad-image",
  "__ad-link": "sponsor-display-module-scss-module__Ak7adW____ad-link",
  "__ad-text": "sponsor-display-module-scss-module__Ak7adW____ad-text",
  "__ad-text-container": "sponsor-display-module-scss-module__Ak7adW____ad-text-container",
  "__tier-one-row": "sponsor-display-module-scss-module__Ak7adW____tier-one-row",
  "__tier-two-row": "sponsor-display-module-scss-module__Ak7adW____tier-two-row",
  "sponsor-display": "sponsor-display-module-scss-module__Ak7adW__sponsor-display",
});
